"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CloseIconNew = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? '#E5E5E5' : _c;
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", width: 62, height: 62, style: {
            height: size + "px",
            width: size + "px",
        }, viewBox: "0 0 62 62" },
        react_1.default.createElement("rect", { width: "62", height: "62", rx: "29", fill: color }),
        react_1.default.createElement("path", { fill: "#4F4F4F", d: "M31 29.1114L37.6114 22.5L39.5 24.3886L32.8886 31L39.5 37.6114L37.6114 39.5L31 32.8886L24.3886 39.5L22.5 37.6114L29.1114 31L22.5 24.3886L24.3886 22.5L31 29.1114Z" })));
};
exports.default = CloseIconNew;
